export const achievementData = {
    bio : "As a full-stack developer and instructor, I have achieved many notable accomplishments since I started my learning journey. My commitment to lifelong learning has been a driving force behind any success I have enjoyed, and I have completed a range of self-development courses through LinkedIn Learning to expand my skillset and knowledge. As an instructor, I have demonstrated a passion for sharing my knowledge with others to further my coding skills. My dedication to self-improvement has also led me to pursue an AWS certification, and I am currently working on a passion project that will give me the hands-on learning experience I need to achieve this goal.",
    achievements : [
        {
            id : 1,
            title : 'Agile Software Development (certification of completion)',
            details : 'In this course, I learn the fundamentals of agile for software developers, as well as why this approach is uniquely suited for software engineering.',
            date : 'September 24, 2021',
            field : 'AgileDevelopment',
            image : 'https://www.richlandlibrary.com/sites/default/files/styles/4to3_1480x1112/public/2021-03/LinkedIn-Learning.png.webp?itok=-CBfUpy9'
        },
        {
            id : 2,
            title : 'Learning Amazon Web Services (AWS) for Developers (certification of completion)',
            details : 'This course provides a high-level overview, focusing on the AWS features and services of the most interest to Software Developers.',
            date : 'December 29, 2022',
            field : 'AWS',
            image : 'https://media.licdn.com/dms/image/C561FAQG39-_S0afyJg/feedshare-document-cover-images_1280/0/1672383800244?e=1679205600&v=beta&t=rLmmzW_ICWYBSjYwuqEEvG8y7m0WxEj3PlSqW7qupSE'
        },
        {
            id : 2,
            title : 'SQL Essential Training (2019) (certification of completion)',
            details : 'SQL Essential Training is designed to help users understand the most common language for database wrangling, SQL. ',
            date : 'July 28, 2021',
            field : 'SQL',
            image : 'https://media.licdn.com/dms/image/C561FAQG39-_S0afyJg/feedshare-document-cover-images_1280/0/1672383800244?e=1679205600&v=beta&t=rLmmzW_ICWYBSjYwuqEEvG8y7m0WxEj3PlSqW7qupSE'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/